import { faqItems } from '@/mocks/homeData';

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            常见问题解答
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            关于51吃瓜官网的入口访问与使用指南，快速解答您的疑问
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {faqItems.map((item) => (
            <div
              key={item.id}
              className="border-b border-background-200/70 last:border-b-0"
            >
              <div className="py-5">
                <h3 className="text-sm md:text-base font-medium text-foreground-800 mb-3 flex items-start gap-3">
                  <span className="w-6 h-6 rounded-full bg-primary-100 text-primary-700 flex items-center justify-center text-xs font-medium flex-shrink-0 mt-0.5">
                    Q
                  </span>
                  {item.question}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed pl-9">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}